export default [{
  name: 'pixmoney',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {}
      },
      Parcela: {},
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaDadosContato: {},
          PessoaEndereco: {}
        },
        Parcela: {},
        PessoaDadosContato: {}
      }
      commit('model', data)
    }
  },
}]
